import React from 'react';
import { string } from 'prop-types';

import { Wrapper } from './styled-components';

const ColoredLabel = ({
  title, color,
}) => (
  <Wrapper {...{ color }}>
    {title}
  </Wrapper>
);

ColoredLabel.propTypes = {
  title: string.isRequired,
  color: string.isRequired,
};

export default ColoredLabel;



// WEBPACK FOOTER //
// ./src/components/colored-label/index.js